export class WdFilterByInstance {
    instanceOfIds;
    subjectOfFilterRecordsMap;
    valueOfFilterRecordsMap;
    classIdsHierarchy;
    constructor(response) {
        this.instanceOfIds = response.results.instanceOfIds;
        this.subjectOfFilterRecordsMap = WdFilterByInstance.buildFilterPropertyRecordsMap(response.results.subjectOfFilterRecords);
        this.valueOfFilterRecordsMap = WdFilterByInstance.buildFilterPropertyRecordsMap(response.results.valueOfFilterRecords);
        this.classIdsHierarchy = response.results.classIdsHierarchy;
    }
    static buildFilterPropertyRecordsMap(filterByInstaceRecords) {
        const newMap = new Map();
        filterByInstaceRecords.forEach((record) => {
            if (!newMap.has(record.propertyId)) {
                newMap.set(record.propertyId, record.rangeIds);
            }
        });
        return newMap;
    }
}
//# sourceMappingURL=get-filter-by-instance.js.map